import React from "react";
import colors from "../colors";
import { ReactComponent as Googleplay } from "../../icons/googleplay.svg";
import { ReactComponent as Appstore } from "../../icons/appstore.svg";
import { ReactComponent as IconEasyPayLogo } from "../../icons/epIconNew.svg";

const DownloadApp = () => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
            backgroundColor: '#f5f7fa'
        }}>
            <div style={{
                backgroundColor: '#fff',
                borderRadius: 24,
                padding: '60px 40px',
                maxWidth: 420,
                width: '90%',
                boxShadow: '0 12px 30px rgba(0, 0, 0, 0.12)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                <IconEasyPayLogo width={'50%'} style={{ marginBottom: 30 }} />
                <p style={{
                    color: colors.darkBlue,
                    textAlign: 'center',
                    fontSize: 20,
                    marginBottom: 35,
                    lineHeight: 1.4,
                }}>
                    Shkarkoni <strong>"EasyPay"</strong> App në mobile:
                </p>
                <div style={{ display: 'flex', gap: 20 }}>
                    <Googleplay
                        style={{ cursor: 'pointer', height: 50 }}
                        onClick={() => window.open('https://play.google.com/store/apps/details?id=al.inovacion.easypay&hl=en&pli=1', '_blank')}
                    />
                    <Appstore
                        style={{ cursor: 'pointer', height: 50 }}
                        onClick={() => window.open('https://apps.apple.com/dz/app/easypay-albania/id950056401', '_blank')}
                    />
                </div>
            </div>
        </div>
    );
};

export default DownloadApp;
